import * as React from 'react';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ReplyIcon} from '../icon/svg/reply-icon';

import styles from './reply-banner.module.css';

export function ReplyBanner() {
    return (
        <div className={styles['reply-banner']}>
            <ReplyIcon wrapWithDiv={false} fill={colors.greyDk} size={15} />
            <div>This message is a reply to the previous message.</div>
        </div>
    );
}
